import { Component, Input, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { BarChartDataItem, PieChartDataItem } from '../../../charts/chart.models';
import { Subject } from 'rxjs';
import {
  CommunicationRecipientStatus,
  MassNotification,
  MassNotificationStats,
  MassNotificationTemplate
} from 'src/app/modules/communications/store/communications/communications.model';
import { v4 as uuidv4 } from 'uuid';
import { ChannelSelectionService } from 'src/app/modules/communications/services/channel-selection-service';
import { TranslateService } from '@ngx-translate/core';
import { NotificationStatusService } from 'src/app/modules/communications/services/notification-status-service';
import { CommunicationsApiService } from 'src/app/modules/management/store/communication-center/communications-api.service';
@Component({
    selector: 'topo-notification-delivery-status-chart-widget',
    templateUrl: './delivery-status-chart-widget.component.html',
    styleUrls: ['./delivery-status-chart-widget.component.scss'],
    standalone: false
})
export class DeliveryStatusChartWidgetComponent implements OnInit, OnDestroy {
  data: BarChartDataItem[];
  chartType: string = 'doughnut';
  showLegend: boolean = true;
  showPercentage: boolean = false;
  showValues: boolean = false;

  private destroy$ = new Subject<void>();

  @Input() width: string;

  @Input() notification: MassNotification;
  @Input() totalRecipients: number;

  _template: MassNotificationTemplate;
  @Input() set template(value: MassNotificationTemplate) {
    this._template = value;
    this.loadChannels(value);
  }

  _stats: MassNotificationStats;
  @Input() set notificationStats(value: MassNotificationStats) {
    this._stats = value;
    this.loadChannelStats(value);
  }

  @ViewChild('canvas') canvas: ElementRef;

  channels: { uid: string; name: string; icon: string }[] = [];
  selectedChannel: { uid: string; name: string; icon: string } = null;

  constructor(
    private channelSelectionService: ChannelSelectionService,
    private translateService: TranslateService,
    private commApiService: CommunicationsApiService,
    private notificationStatusService: NotificationStatusService
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadChannelStats(stats: MassNotificationStats): void {
    this.data = [];

    this.showPercentage = true;
    this.showValues = true;

    const sets: { status: any; count: number }[] = [];

    if (!!!stats?.channelStats) {
      const stat = { status: CommunicationRecipientStatus.None, count: 1 };
      sets.push(stat);
    }

    if (!!!this.selectedChannel?.uid) {
      stats?.channelStats?.forEach(s => {
        s?.statusCounts?.forEach(c => {
          if (!!c) {
            const status = !!c.status ? c.status : CommunicationRecipientStatus.None;
            let stat = sets.find(v => v.status === status);
            if (!!!stat) {
              stat = { status: status, count: c.count };
              sets.push(stat);
            } else {
              stat.count += c.count;
            }
          }
        });
      });
    } else {
      const channelStat = stats?.channelStats?.find(s => s.configuredChannelUId === this.selectedChannel?.uid);
      if (!!!channelStat) {
        const stat = { status: CommunicationRecipientStatus.None, count: 1 };
        sets.push(stat);
      }
      channelStat?.statusCounts?.forEach(c => {
        if (!!c) {
          const status = !!c.status ? c.status : CommunicationRecipientStatus.None;
          sets.push({
            status: status,
            count: c.count
          });
        }
      });
    }

    sets.forEach(s => {
      const data = {
        id: uuidv4(),
        data: [],
        label: this.translateService.instant(
          'COMMUNICATIONS.RECIPIENT-SEND-STATUS-' + (!!s.status ? s.status : CommunicationRecipientStatus.None)
        ),
        label2: null
      };
      data.data.push({
        id: s.status.toString(),
        count: s.count,
        color: this.notificationStatusService.getRecipientStatusColor(s.status),
        textColor: '#404040',
        label: this.translateService.instant(
          'COMMUNICATIONS.RECIPIENT-SEND-STATUS-' + (!!s.status ? s.status : CommunicationRecipientStatus.None)
        )
      });
      this.data.push(data);
    });
  }

  private loadChannels(template: MassNotificationTemplate): void {
    this.channels = [];
    this.channels.push({
      uid: null,
      name: this.translateService.instant('COMMUNICATIONS.ALL-CHANNELS'),
      icon: 'icon-satellite-dish'
    });

    const avlChannel = this.channelSelectionService.getUniqueConfiguredChannels(this.notification?.channelsCascadeSettings);
    avlChannel.forEach(c => {
      this.channels.push({
        uid: c.uId,
        name: c.name,
        icon: this.channelSelectionService.getChannelIcon(c.channelUId)
      });
    });
    this.selectedChannel = this.channels[0];
  }

  getSelectedChannel(uid: string): any {
    return this.channels?.find(c => c.uid === uid);
  }

  selectedChannelChanged(channel: any): void {
    this.selectedChannel = this.channels.find(c => c.uid === channel.uid);
    this.loadChannelStats(this._stats);
  }

  selected(data: { item: BarChartDataItem; subValue: any }): void {}
}
